document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mh-rsc-hero_carousel", {
    slidesPerView: 1,
    speed: 700,
    allowTouchMove: true,
    loop: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    pagination: {
      el: ".mh-rsc-hero_carousel .mh-rsc-hero_pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".mh-rsc-hero_carousel .mh-rsc-hero_navbtn-next",
      prevEl: ".mh-rsc-hero_carousel .mh-rsc-hero_navbtn-prev",
    },
  });
});

(function () {
  function boot() {
    var sections = document.querySelectorAll('.mh-rsc-prd-showcase_wrapper');
    if (!sections.length) return;

    function destroyActive(sectionEl) {
      var inst = sectionEl.__activeInst;
      if (inst && inst.destroy) {
        try { inst.destroy(true, true); } catch (e) {}
      }
      sectionEl.__activeInst = null;
      sectionEl.__activePanel = null;
      sectionEl.__activeSwiperEl = null;

      if (sectionEl.__mhRecObserver) {
        try { sectionEl.__mhRecObserver.disconnect(); } catch (e) {}
      }
      sectionEl.__mhRecObserver = null;
    }

    function buildConfig(swiperEl) {
      var paginationSel = swiperEl.getAttribute('data-pagination');
      var scrollbarSel  = swiperEl.getAttribute('data-scrollbar');

      var paginationEl = paginationSel ? document.querySelector(paginationSel) : null;
      var scrollbarEl  = scrollbarSel ? document.querySelector(scrollbarSel) : null;

      var cfg = {
        slidesPerView: 5,
        spaceBetween: 16,
        allowTouchMove: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          0:    { slidesPerView: 2,   spaceBetween: 12 },
          480:  { slidesPerView: 2, spaceBetween: 12 },
          750:  { slidesPerView: 3, spaceBetween: 16 },
          990:  { slidesPerView: 4, spaceBetween: 16 },
          1320:  { slidesPerView: 5, spaceBetween: 16 },
          1920: { slidesPerView: 6,   spaceBetween: 16 }
        }
      };

      if (paginationEl) cfg.pagination = { el: paginationEl, clickable: true };
      if (scrollbarEl)  cfg.scrollbar  = { el: scrollbarEl, draggable: true, hide: false, snapOnRelease: true };

      return cfg;
    }

    function initSwiper(sectionEl, panelEl) {
      var layout = sectionEl.getAttribute('data-layout') || 'carousel';
      if (layout !== 'carousel') {
        destroyActive(sectionEl);
        return;
      }

      if (typeof Swiper === 'undefined') {
        console.warn('[RSC Product Showcase] Swiper missing');
        return;
      }

      // ✅ fallback for recommendation section (no panels)
      var scopeEl = panelEl || sectionEl;

      var swiperEl = scopeEl.querySelector('.mh-rsc-prd-showcase_carousel.swiper');
      if (!swiperEl) return;

      // ✅ if we are in no-panel mode, keep one instance per section
      if (sectionEl.__activeInst && sectionEl.__activeSwiperEl === swiperEl) {
        sectionEl.__activeInst.update && sectionEl.__activeInst.update();
        if (sectionEl.__activeInst.scrollbar && sectionEl.__activeInst.scrollbar.updateSize) {
          sectionEl.__activeInst.scrollbar.updateSize();
        }
        return;
      }

      // destroy previous, then init
      if (sectionEl.__activeInst && sectionEl.__activeInst.destroy) {
        try { sectionEl.__activeInst.destroy(true, true); } catch (e) {}
      }
      sectionEl.__activeInst = null;
      sectionEl.__activePanel = null;
      sectionEl.__activeSwiperEl = null;

      var instance = new Swiper(swiperEl, buildConfig(swiperEl));
      sectionEl.__activeInst = instance;
      sectionEl.__activePanel = panelEl || null;
      sectionEl.__activeSwiperEl = swiperEl;

      if (instance.scrollbar && instance.scrollbar.updateSize) instance.scrollbar.updateSize();
    }

    // ✅ Observe Dawn <product-recommendations> injection and init swiper after content arrives
    function setupRecommendationsObserver(sectionEl) {
      if (!sectionEl || sectionEl.__mhRecObserver) return;

      var pr = sectionEl.querySelector('product-recommendations');
      if (!pr) return;

      // if markup already exists, init now
      if (pr.querySelector('.mh-rsc-prd-showcase_carousel.swiper')) {
        initSwiper(sectionEl, null);
        return;
      }

      var obs = new MutationObserver(function () {
        var hasSwiper = pr.querySelector('.mh-rsc-prd-showcase_carousel.swiper');
        if (hasSwiper) {
          initSwiper(sectionEl, null);
          try { obs.disconnect(); } catch (e) {}
          sectionEl.__mhRecObserver = null;
        }
      });

      obs.observe(pr, { childList: true, subtree: true });
      sectionEl.__mhRecObserver = obs;
    }

    function splitTracks(str) {
      var tracks = [];
      var cur = '';
      var depth = 0;

      for (var i = 0; i < str.length; i++) {
        var ch = str[i];
        if (ch === '(') depth++;
        if (ch === ')') depth = Math.max(0, depth - 1);

        if (ch === ' ' && depth === 0) {
          if (cur.trim()) tracks.push(cur.trim());
          cur = '';
        } else {
          cur += ch;
        }
      }
      if (cur.trim()) tracks.push(cur.trim());
      return tracks;
    }

    function getColsFromComputedGrid(gridInner) {
      if (!gridInner) return 1;
      try {
        var tpl = window.getComputedStyle(gridInner).gridTemplateColumns || '';
        if (!tpl || tpl === 'none') return 1;
        var tracks = splitTracks(tpl.trim());
        return Math.max(1, tracks.length || 1);
      } catch (e) {
        return 1;
      }
    }

    function collapseGridToInitial(panelEl, sectionEl) {
      var layout = sectionEl.getAttribute('data-layout') || 'carousel';
      var mode = sectionEl.getAttribute('data-grid-button-mode') || 'none';
      if (layout !== 'grid' || mode !== 'load_more') return;

      if (!panelEl) return;

      var gridInner = panelEl.querySelector('.mh-rsc-prd-showcase_grid-inner');
      if (!gridInner) return;

      var items = gridInner.querySelectorAll('.mh-rsc-prd-showcase_grid-item');
      if (!items.length) return;

      var initialCount = parseInt(gridInner.getAttribute('data-initial-count') || '0', 10);

      if (!initialCount || isNaN(initialCount) || initialCount < 1) {
        var cols = getColsFromComputedGrid(gridInner);
        initialCount = Math.min(items.length, cols * 2); // 2 rows
        gridInner.setAttribute('data-initial-count', String(initialCount));
      }

      var i = 0;
      items.forEach(function (item) {
        i++;
        if (i <= initialCount) {
          item.removeAttribute('data-hidden');
          item.style.display = '';
        } else {
          item.setAttribute('data-hidden', '1');
          item.style.display = 'none';
        }
      });
    }

    function syncLoadMoreButton(sectionEl) {
      var btn = sectionEl.querySelector('.mh-rsc-prd-showcase_cta-load-more');
      if (!btn) return;

      var labelMore = btn.getAttribute('data-label-more') || 'Show more products';
      var labelEl = btn.querySelector('.btn-primary-text') || btn;

      btn.setAttribute('data-expanded', '0');
      labelEl.textContent = labelMore;
    }

    function updateCollectionCTA(sectionEl, panelEl) {
      var cta = sectionEl.querySelector('.mh-rsc-prd-showcase_cta-collection');
      if (!cta || !panelEl) return;
      var url = panelEl.getAttribute('data-collection-url') || '#';
      cta.setAttribute('href', url);
    }

    function showPanel(sectionEl, targetPanel) {
      var panels = sectionEl.querySelectorAll('.mh-rsc-prd-showcase_panel');
      panels.forEach(function (el) {
        if (el === targetPanel) {
          el.hidden = false;
          el.removeAttribute('hidden');
          el.style.display = '';
        } else {
          el.setAttribute('hidden', '');
          el.hidden = true;
          el.style.display = 'none';
        }
      });

      collapseGridToInitial(targetPanel, sectionEl);
      syncLoadMoreButton(sectionEl);

      initSwiper(sectionEl, targetPanel);
      updateCollectionCTA(sectionEl, targetPanel);
    }

    function initSection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.mhTabsInited === '1') return;
      sectionEl.dataset.mhTabsInited = '1';

      // ✅ for recommendations: watch injected content and init swiper when it appears
      setupRecommendationsObserver(sectionEl);

      var tabButtons = sectionEl.querySelectorAll('.mh-rsc-prd-showcase_tab');
      var selectEl = sectionEl.querySelector('.mh-rsc-prd-showcase_select-el');

      var firstVisible = sectionEl.querySelector('.mh-rsc-prd-showcase_panel:not([hidden])');
      var allPanels = sectionEl.querySelectorAll('.mh-rsc-prd-showcase_panel');
      var initialPanel = firstVisible || allPanels[0];

      // ✅ If no panels (recommendations clone), init swiper directly (if markup already exists)
      if (!initialPanel) {
        initSwiper(sectionEl, null);
      } else {
        initialPanel.hidden = false;
        initialPanel.removeAttribute('hidden');
        showPanel(sectionEl, initialPanel);
        if (selectEl && initialPanel.id) selectEl.value = initialPanel.id;
      }

      if (tabButtons.length) {
        tabButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            tabButtons.forEach(function (b) {
              b.classList.remove('mh-rsc-prd-showcase_tab--active');
              b.setAttribute('aria-selected', 'false');
            });

            btn.classList.add('mh-rsc-prd-showcase_tab--active');
            btn.setAttribute('aria-selected', 'true');

            var targetId = btn.getAttribute('data-rsc-tab-target');
            if (!targetId) return;

            var panel = sectionEl.querySelector('#' + targetId);
            if (!panel) return;

            if (selectEl) selectEl.value = targetId;
            showPanel(sectionEl, panel);
          });
        });
      }

      if (selectEl) {
        selectEl.addEventListener('change', function () {
          var targetId = this.value;
          var panel = sectionEl.querySelector('#' + targetId);
          if (!panel) return;

          tabButtons.forEach(function (b) {
            var tid = b.getAttribute('data-rsc-tab-target');
            var isActive = (tid === targetId);
            b.classList.toggle('mh-rsc-prd-showcase_tab--active', isActive);
            b.setAttribute('aria-selected', String(isActive));
          });

          showPanel(sectionEl, panel);
        });
      }

      // Load more / less (grid only)
      var loadMoreBtn = sectionEl.querySelector('.mh-rsc-prd-showcase_cta-load-more');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          var activePanel = sectionEl.querySelector('.mh-rsc-prd-showcase_panel:not([hidden])');

          // ✅ if no panels (recommendations clone), try to scope to section directly
          var scope = activePanel || sectionEl;

          var gridInner = scope.querySelector('.mh-rsc-prd-showcase_grid-inner');
          if (!gridInner) return;

          var items = gridInner.querySelectorAll('.mh-rsc-prd-showcase_grid-item');
          if (!items.length) return;

          var labelMore = loadMoreBtn.getAttribute('data-label-more') || 'Show more products';
          var labelLess = loadMoreBtn.getAttribute('data-label-less') || 'Show less products';
          var labelEl = loadMoreBtn.querySelector('.btn-primary-text') || loadMoreBtn;

          var isExpanded = loadMoreBtn.getAttribute('data-expanded') === '1';

          if (!isExpanded) {
            items.forEach(function (item) {
              item.removeAttribute('data-hidden');
              item.style.display = '';
            });
            loadMoreBtn.setAttribute('data-expanded', '1');
            labelEl.textContent = labelLess;
          } else {
            if (activePanel) {
              collapseGridToInitial(activePanel, sectionEl);
              activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            loadMoreBtn.setAttribute('data-expanded', '0');
            labelEl.textContent = labelMore;
          }
        });
      }
    }

    sections.forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = document.getElementById('shopify-section-' + (e.detail && e.detail.sectionId));
      if (!root) return;

      root.querySelectorAll('.mh-rsc-prd-showcase_wrapper').forEach(function (sec) {
        destroyActive(sec);
        sec.dataset.mhTabsInited = '';
        initSection(sec);
      });
    });
  }

  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();


(function () {
  var WRAPPER_SELECTOR = '.mh-rsc-clctn-showcase_wrapper';

  // ---------------------------------------------------------------------------
  // SWIPER DESTROY
  // ---------------------------------------------------------------------------
  function mhRscClctnDestroySwiper(wrapper) {
    var inst = wrapper.__mhRscClctnSwiper;
    if (inst && typeof inst.destroy === 'function') {
      try {
        inst.destroy(true, true);
      } catch (e) {}
    }
    wrapper.__mhRscClctnSwiper = null;
  }

  // Simple helper like product script
  function mhRscClctnParseFloat(attrValue, fallback) {
    var n = parseFloat(attrValue);
    if (!isFinite(n) || isNaN(n)) return fallback;
    return n;
  }

  // ---------------------------------------------------------------------------
  // SWIPER INIT (CAROUSEL) – MIRRORS PRODUCT PATTERN
  // ---------------------------------------------------------------------------
  function mhRscClctnInitSwiper(wrapper) {
    var layout = wrapper.getAttribute('data-layout') || 'carousel';
    if (layout !== 'carousel') {
      mhRscClctnDestroySwiper(wrapper);
      return;
    }

    if (typeof Swiper === 'undefined') {
      console.warn('[RSC Collections] Swiper not found');
      return;
    }

    var swiperEl = wrapper.querySelector('.mh-rsc-clctn-showcase_carousel.swiper');
    if (!swiperEl) {
      mhRscClctnDestroySwiper(wrapper);
      return;
    }

    // Prevent double init on this wrapper
    mhRscClctnDestroySwiper(wrapper);

    // Space between slides from swiper element
    var spaceMobileAttr = swiperEl.getAttribute('data-space-mobile');
    var spaceMediumAttr = swiperEl.getAttribute('data-space-medium');
    var spaceDesktopAttr = swiperEl.getAttribute('data-space-desktop');

    var spaceMobile = parseInt(spaceMobileAttr || '16', 10);
    var spaceMedium = parseInt(spaceMediumAttr || spaceMobile || '20', 10);
    var spaceDesktop = parseInt(spaceDesktopAttr || spaceMedium || '24', 10);

    // Slides per view from WRAPPER (same as product script)
    var slidesXs = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-xs') || '2',
      2
    );
    var slidesSm = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-sm') || slidesXs,
      2
    );
    var slidesMd = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-md') || slidesSm,
      3
    );
    var slidesLg = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-lg') || slidesMd,
      4
    );
    var slidesXl = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-xl') || slidesLg,
      5
    );
    var slides2xl = mhRscClctnParseFloat(
      wrapper.getAttribute('data-slides-2xl') || slidesXl,
      6
    );

    // Nav / pagination / scrollbar selectors from swiper element
    var paginationSel = swiperEl.getAttribute('data-pagination');
    var scrollbarSel = swiperEl.getAttribute('data-scrollbar');
    var navPrevSel = swiperEl.getAttribute('data-nav-prev');
    var navNextSel = swiperEl.getAttribute('data-nav-next');

    function findTarget(selector) {
      if (!selector) return null;
      // Prefer element inside this wrapper, then fallback
      var inside = wrapper.querySelector(selector);
      if (inside) return inside;
      return document.querySelector(selector);
    }

    var paginationEl = paginationSel ? findTarget(paginationSel) : null;
    var scrollbarEl = scrollbarSel ? findTarget(scrollbarSel) : null;
    var navPrevEl = navPrevSel ? findTarget(navPrevSel) : null;
    var navNextEl = navNextSel ? findTarget(navNextSel) : null;

    var cfg = {
      slidesPerView: slidesLg,
      spaceBetween: spaceDesktop,
      allowTouchMove: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      mousewheel: { forceToAxis: true },
      loop: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: slidesXs,
          spaceBetween: spaceMobile
        },
        580: {
          slidesPerView: slidesSm,
          spaceBetween: spaceMobile
        },
        750: {
          slidesPerView: slidesMd,
          spaceBetween: spaceMedium
        },
        990: {
          slidesPerView: slidesLg,
          spaceBetween: spaceMedium
        },
        1320: {
          slidesPerView: slidesXl,
          spaceBetween: spaceDesktop
        },
        1920: {
          slidesPerView: slides2xl,
          spaceBetween: spaceDesktop
        }
      }
    };

    if (paginationEl) {
      cfg.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (scrollbarEl) {
      cfg.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        hide: false,
        snapOnRelease: true
      };
    }

    if (navPrevEl && navNextEl) {
      cfg.navigation = {
        prevEl: navPrevEl,
        nextEl: navNextEl
      };
    }

    try {
      wrapper.__mhRscClctnSwiper = new Swiper(swiperEl, cfg);

      // Small delayed update in case fonts/layout shift after DOMContentLoaded
      setTimeout(function () {
        if (wrapper.__mhRscClctnSwiper && wrapper.__mhRscClctnSwiper.update) {
          wrapper.__mhRscClctnSwiper.update();
        }
      }, 120);
    } catch (err) {
      console.error('[RSC Collections] Swiper init error', err);
    }
  }

  // ---------------------------------------------------------------------------
  // GRID HELPERS
  // ---------------------------------------------------------------------------
  function mhRscClctnGetGridColumns(gridInner) {
    var cols = 0;
    try {
      var style = window.getComputedStyle(gridInner);
      var template = style.gridTemplateColumns || '';
      if (template) {
        cols = template.split(' ').length;
      }
    } catch (e) {}
    if (!cols || isNaN(cols) || cols < 1) cols = 1;
    return cols;
  }

  function mhRscClctnSetupGridInitial(wrapper) {
    var layout = wrapper.getAttribute('data-layout') || 'carousel';
    if (layout !== 'grid') return;

    var buttonMode = wrapper.getAttribute('data-grid-button-mode') || 'none';
    var gridInner = wrapper.querySelector('.mh-rsc-clctn-showcase_grid-inner');
    if (!gridInner) return;

    var items = Array.prototype.slice.call(
      gridInner.querySelectorAll('.mh-rsc-clctn-showcase_grid-item')
    );
    var total = items.length;
    if (!total) return;

    var loadMoreBtn = wrapper.querySelector(
      '.mh-rsc-clctn-showcase_cta-load-more'
    );

    function showAll() {
      items.forEach(function (item) {
        item.removeAttribute('data-hidden');
        item.style.removeProperty('display');
      });
      gridInner.dataset.initialCount = String(total);
      gridInner.dataset.visibleCount = String(total);
      gridInner.dataset.pageSize = '0';
      gridInner.dataset.totalCount = String(total);
    }

    // If no load-more mode, just show everything
    if (buttonMode !== 'load_more') {
      showAll();
      return;
    }

    var cols = mhRscClctnGetGridColumns(gridInner);
    var rowsInitial = 2;
    var initialCount = cols * rowsInitial;
    if (initialCount > total) initialCount = total;
    var pageSize = cols;
    if (pageSize < 1) pageSize = 1;

    // If everything fits into the initial view, hide CTA and show all
    if (total <= initialCount) {
      showAll();
      if (loadMoreBtn) {
        loadMoreBtn.style.display = 'none';
      }
      return;
    }

    // Load-more initial state: two rows visible, rest hidden
    items.forEach(function (item, index) {
      var i = index + 1;
      if (i <= initialCount) {
        item.removeAttribute('data-hidden');
        item.style.removeProperty('display');
      } else {
        item.setAttribute('data-hidden', '1');
        item.style.display = 'none';
      }
    });

    gridInner.dataset.initialCount = String(initialCount);
    gridInner.dataset.visibleCount = String(initialCount);
    gridInner.dataset.pageSize = String(pageSize);
    gridInner.dataset.totalCount = String(total);
  }

  function mhRscClctnAttachGridLoadMore(wrapper) {
    var layout = wrapper.getAttribute('data-layout') || 'carousel';
    if (layout !== 'grid') return;

    var buttonMode = wrapper.getAttribute('data-grid-button-mode') || 'none';
    if (buttonMode !== 'load_more') return;

    var btn = wrapper.querySelector('.mh-rsc-clctn-showcase_cta-load-more');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var gridInner = wrapper.querySelector('.mh-rsc-clctn-showcase_grid-inner');
      if (!gridInner) return;

      var items = gridInner.querySelectorAll('.mh-rsc-clctn-showcase_grid-item');
      var total = items.length;
      if (!total) return;

      var initialCount = parseInt(gridInner.dataset.initialCount || '0', 10);
      var visibleCount = parseInt(
        gridInner.dataset.visibleCount || initialCount || '0',
        10
      );
      var pageSize = parseInt(gridInner.dataset.pageSize || '0', 10);

      if (!pageSize || isNaN(pageSize) || pageSize < 1) {
        pageSize = mhRscClctnGetGridColumns(gridInner);
        if (!pageSize || isNaN(pageSize) || pageSize < 1) pageSize = 1;
      }

      var labelMore = btn.getAttribute('data-label-more') || 'Load more';
      var labelLess = btn.getAttribute('data-label-less') || 'Show less';
      var labelEl = btn.querySelector('.btn-primary-text') || btn;

      if (visibleCount < total) {
        var nextVisible = visibleCount + pageSize;
        if (nextVisible > total) nextVisible = total;

        Array.prototype.forEach.call(items, function (item, index) {
          var i = index + 1;
          if (i <= nextVisible) {
            item.removeAttribute('data-hidden');
            item.style.removeProperty('display');
          }
        });

        gridInner.dataset.visibleCount = String(nextVisible);

        if (nextVisible >= total) {
          btn.setAttribute('data-expanded', '1');
          labelEl.textContent = labelLess;
        } else {
          btn.setAttribute('data-expanded', '0');
          labelEl.textContent = labelMore;
        }
      } else {
        Array.prototype.forEach.call(items, function (item, index) {
          var i = index + 1;
          if (i <= initialCount) {
            item.removeAttribute('data-hidden');
            item.style.removeProperty('display');
          } else {
            item.setAttribute('data-hidden', '1');
            item.style.display = 'none';
          }
        });

        gridInner.dataset.visibleCount = String(initialCount);
        btn.setAttribute('data-expanded', '0');
        labelEl.textContent = labelMore;

        gridInner.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // ---------------------------------------------------------------------------
  // SECTION INIT
  // ---------------------------------------------------------------------------
  function mhRscClctnInitSection(wrapper) {
    if (!wrapper || wrapper.dataset.mhRscClctnInited === '1') return;
    wrapper.dataset.mhRscClctnInited = '1';

    var layout = wrapper.getAttribute('data-layout') || 'carousel';

    if (layout === 'carousel') {
      mhRscClctnInitSwiper(wrapper);
    } else {
      mhRscClctnDestroySwiper(wrapper);
    }

    mhRscClctnSetupGridInitial(wrapper);
    mhRscClctnAttachGridLoadMore(wrapper);
  }

  function mhRscClctnInitAll() {
    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers.length) return;
    Array.prototype.forEach.call(wrappers, mhRscClctnInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mhRscClctnInitAll);
  } else {
    mhRscClctnInitAll();
  }

  // Shopify editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var sectionId = e && e.detail && e.detail.sectionId;
    if (!sectionId) return;

    var root = document.getElementById('shopify-section-' + sectionId);
    if (!root) return;

    var wrappers = root.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers.length && root.classList.contains('mh-rsc-clctn-showcase_wrapper')) {
      wrappers = [root];
    }

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      mhRscClctnDestroySwiper(wrapper);
      wrapper.__mhRscClctnSwiper = null;
      wrapper.dataset.mhRscClctnInited = '';
      mhRscClctnInitSection(wrapper);
    });
  });
})();


document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll(
    '.mh-rsc-info-iconbox_wrapper[data-section-id]'
  );

  if (!wrappers.length || typeof Swiper === 'undefined') {
    return;
  }

  wrappers.forEach(function (wrapper) {
    var carouselEl = wrapper.querySelector(
      '.mh-rsc-info-iconbox_carousel.swiper'
    );
    if (!carouselEl) return;

    var ds = carouselEl.dataset;

    var slidesXs = parseFloat(ds.slidesXs || '1.3');
    var slidesSm = parseFloat(ds.slidesSm || '1.8');
    var slidesMd = parseFloat(ds.slidesMd || '2.4');
    var slidesLg = parseFloat(ds.slidesLg || '3.5');

    var spaceMobile = parseInt(ds.spaceMobile || '16', 10);
    var spaceMedium = parseInt(ds.spaceMedium || '20', 10);
    var spaceDesktop = parseInt(ds.spaceDesktop || '24', 10);

    var hasNavSetting = wrapper.getAttribute('data-show-nav') === 'true';
    var hasPaginationSetting = wrapper.getAttribute('data-show-pagination') === 'true';

    var prevBtn = wrapper.querySelector('[data-info-iconbox-nav="prev"]');
    var nextBtn = wrapper.querySelector('[data-info-iconbox-nav="next"]');
    var paginationEl = wrapper.querySelector('[data-info-iconbox-pagination]');
    var contentInnerBlock = wrapper.querySelector(
      '.mh-rsc-info-iconbox_content-inner--block'
    );

    var swiperOptions = {
      slidesPerView: slidesXs,
      spaceBetween: spaceMobile,
      speed: 500,
      loop: false,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: slidesSm,
          spaceBetween: spaceMedium
        },
        990: {
          slidesPerView: slidesMd,
          spaceBetween: spaceMedium
        },
        1320: {
          slidesPerView: slidesLg,
          spaceBetween: spaceDesktop
        }
      }
    };

    if (hasNavSetting && prevBtn && nextBtn) {
      swiperOptions.navigation = {
        prevEl: prevBtn,
        nextEl: nextBtn
      };
    }

    if (hasPaginationSetting && paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    var swiper = new Swiper(carouselEl, swiperOptions);

    function getCurrentSlidesPerView() {
      var w = window.innerWidth || document.documentElement.clientWidth;
      if (w >= 1320) return slidesLg;
      if (w >= 990) return slidesMd;
      if (w >= 750) return slidesSm;
      return slidesXs;
    }

    function updateInfoIconboxControlsVisibility() {
      // With loop:false this is just your real card count
      var totalSlides = swiper.slides ? swiper.slides.length : 0;
      var currentSpv = getCurrentSlidesPerView();

      // overflow = there are more cards than can be shown at once
      var overflow = totalSlides > currentSpv + 0.01;

      var navShouldShow = hasNavSetting && overflow;
      var paginationShouldShow = hasPaginationSetting && overflow;

      // Nav buttons visibility + wrapper state
      if (prevBtn && nextBtn) {
        var navDisplay = navShouldShow ? '' : 'none';
        prevBtn.style.display = navDisplay;
        nextBtn.style.display = navDisplay;
      }
      wrapper.classList.toggle('info-iconbox--nav-visible', navShouldShow);

      // Pagination visibility + wrapper state
      if (paginationEl) {
        paginationEl.style.display = paginationShouldShow ? '' : 'none';
      }
      wrapper.classList.toggle(
        'info-iconbox--pagination-visible',
        paginationShouldShow
      );

      // 👉 Class on inner block: true only when nav is actually visible
      if (contentInnerBlock) {
        contentInnerBlock.classList.toggle(
          'mh-rsc-info-iconbox_content-inner--block--has-nav',
          navShouldShow
        );
      }
    }

    updateInfoIconboxControlsVisibility();

    swiper.on('resize', updateInfoIconboxControlsVisibility);
    swiper.on('slideChange', updateInfoIconboxControlsVisibility);
  });
});

(function () {
  if (typeof Swiper === "undefined") {
    return;
  }

  function initRscHeroSections() {
    var wrappers = document.querySelectorAll(
      ".mh-rsc-hero_wrapper[data-section-id]"
    );
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var carouselEl = wrapper.querySelector(".mh-rsc-hero_carousel.swiper");
      if (!carouselEl) return;

      // Avoid double init
      if (carouselEl.dataset.heroInitialized === "true") return;
      carouselEl.dataset.heroInitialized = "true";

      var slides = carouselEl.querySelectorAll(
        ".mh-rsc-hero_carousel-slide.swiper-slide"
      );
      if (!slides.length) return;

      var showNavSetting =
        wrapper.getAttribute("data-show-nav") === "true";
      var showPaginationSetting =
        wrapper.getAttribute("data-show-pagination") === "true";

      var effectSetting = wrapper.getAttribute("data-hero-effect") || "slide";

      var hasMultiple = slides.length > 1;

      var prevEl =
        showNavSetting && hasMultiple
          ? wrapper.querySelector('[data-hero-nav="prev"]')
          : null;
      var nextEl =
        showNavSetting && hasMultiple
          ? wrapper.querySelector('[data-hero-nav="next"]')
          : null;
      var paginationEl =
        showPaginationSetting && hasMultiple
          ? wrapper.querySelector("[data-hero-pagination]")
          : null;

      if (!hasMultiple) {
        wrapper.classList.add("mh-rsc-hero--single-slide");
      }

      if (prevEl && nextEl) {
        wrapper.classList.add("mh-rsc-hero--nav-visible");

        // NEW: mark slides when nav is visible
        slides.forEach(function (slide) {
          slide.classList.add("mh-rsc-hero-slide--has-nav");
        });
      } else {
        wrapper.classList.add("mh-rsc-hero--nav-hidden");
      }

      if (paginationEl) {
        wrapper.classList.add("mh-rsc-hero--pagination-visible");
      } else {
        wrapper.classList.add("mh-rsc-hero--pagination-hidden");
      }

      var swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: hasMultiple,
        watchOverflow: true,
        effect: effectSetting === "fade" ? "fade" : "slide"
      };

      if (effectSetting === "fade") {
        swiperConfig.fadeEffect = {
          crossFade: true
        };
      }

      if (prevEl && nextEl) {
        swiperConfig.navigation = {
          prevEl: prevEl,
          nextEl: nextEl
        };
      }

      if (paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      new Swiper(carouselEl, swiperConfig);
    });
  }

  document.addEventListener("DOMContentLoaded", initRscHeroSections);

  document.addEventListener("shopify:section:load", function (event) {
    if (
      event &&
      event.target &&
      event.target.querySelector(".mh-rsc-hero_wrapper")
    ) {
      initRscHeroSections();
    }
  });
})();